import { Component, OnInit, NgZone, ViewChild, AfterContentInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatSliderModule} from '@angular/material/slider';
import {take} from 'rxjs/operators';
import {FlatTreeControl} from '@angular/cdk/tree';
import {Location} from '@angular/common';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class DocumentComponent implements OnInit {

  constructor(private _location: Location, private _ngZone: NgZone, public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  showInvoiceVisualizer:boolean;
  showURLError:boolean;

  DocumentID:string;
  TypeID:number;
  CompanyID:number;
  IsDifferentCompanyThanOriginal:boolean = false;

  ngOnInit(): void {
    this.parent.loading = true;
    this.GetParametersFromURL();
  }
 
  GetParametersFromURL(){
    this.route.queryParams.subscribe(params => {      
      this.DocumentID = params['DocumentID'];
      this.TypeID = JSON.parse(params['TypeID']);

      if(params['Company'] != null){
        this.CompanyID = JSON.parse(params['Company']);
      }
    });

    if(!this.DocumentID || !this.TypeID){
      this.showURLError = true;
    }
    else{
      this.GetDocumentInformation();
    }
  }

  backClicked() {
    this._location.back();
  }

  GetDocumentInformation(){

    if(this.CompanyID != null && this.parent.Company.ID != this.CompanyID){
      this.parent.User.Rights.AssignedCompanies.forEach(element => {
        element.IsSelected = false;

        if(element.ID == this.CompanyID){
          element.IsSelected = true;
          this.IsDifferentCompanyThanOriginal = true;
        }
      });
    }
    
    if(this.TypeID == 1){
      this.GetReception(this.DocumentID)
    }
    else if(this.TypeID == 2){
      this.GetInvoice(this.DocumentID, false, false);
    }

  }

  IsStorno:boolean = false;
  NewCopy:boolean = false;
  DocumentBodyLoading:boolean;
  ShowDeactivateDocumentQuestion:boolean;
  ShowReactivateDocumentQuestion:boolean;

  partner:any;
  CurrentInvoice:any;
  currency:any;
  InvoicePrecision:any;
  Products:any[];

  //invoice

  GetInvoice(id:string, UseInvoiceLanguage:boolean, TransferAdvancedPaymentValues:boolean = false){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      NewCopy:this.NewCopy,
      UseInvoiceLanguage:UseInvoiceLanguage,
      TransferAdvancedPaymentValues:TransferAdvancedPaymentValues
    };

    this.service.GetInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.showURLError = true;
      }
      else if(response["Status"] == 1){
        this.FillInvoiceInfo(response["Invoice"]);
        this.showInvoiceVisualizer = true;
      }

      this.parent.loading = false;
    });
  }

  FillInvoiceInfo(invoice:any){

    this.partner = {};
    this.CurrentInvoice = invoice;
    this.partner = this.CurrentInvoice.Client;

    this.currency = invoice.Currency;

    if(invoice.Products.length > 0){
    this.InvoicePrecision = invoice.Products[0].ProductInvoiceInfo.DecimalPrecision;
    }

    this.Products = invoice.Products;
    }

    PrintInvoice(i:any){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        InvoiceID:i.ID,
      };
    
      this.DocumentBodyLoading = true;
    
      this.service.ExportInvoice(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.printPage(Document.Name , Document.PDFStream, Document.ID);
        }
    
        this.DocumentBodyLoading = false;
      });
    }
    
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
    
      element.style.display = 'none';
      document.body.appendChild(element);
    
      element.click();
    
      document.body.removeChild(element);
    }

    printPage(name:string, html:string, ID:string) {
      var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
      'resizable,screenX=50,screenY=50,width=850,height=1050';
    
    var htmlPop = '<embed width=100% height=100%'
      + ' type="application/pdf"'
      + ' src="data:application/pdf;base64,'
      + escape(html)
      + '"></embed>';
    
    var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
    newWindow.document.write(htmlPop);
    };
    
    ExportInvoice(i:any){
    
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        InvoiceID:i.ID,
      };
    
      this.DocumentBodyLoading = true;
    
      this.service.ExportInvoice(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.download(Document.Name, Document.PDFStream);
        }
    
        this.DocumentBodyLoading = false;
      });
    }

    ViewInvoice(i:any){

      if(i.DocumentStatus.ID == -1){
        return;
      }
    
      this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, user: this.parent.User.Id } }); 
    }

    GenerateInvoicesDeliveryNote(i:any){
      var invoices = [];
      invoices.push(i);
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Invoices:invoices
      };
    
      this.parent.loading = true;
    
      this.service.GenerateInvoicesDeliveryNote(request).subscribe(response => {
     
        if(response["Status"] == -1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.printPage(Document.Name , Document.PDFStream, Document.ID);
        }
    
        this.parent.loading = false;
      });
    }

    GenerateNewInvoice(i:any, storno:boolean, newCopy:boolean){
      this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, IsStorno: storno, NewCopy:newCopy } }); 
    }

    CancelOrActivate(InvoiceID:string,CancelInvoice:boolean){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        InvoiceID:InvoiceID,
        CancelInvoice:CancelInvoice,
      };
    
      this.DocumentBodyLoading = true;
    
      this.service.CancelOrActivate(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 1000000);
         this.GetInvoice(this.DocumentID, false, false);
    
         if(this.CurrentInvoice != null && this.CurrentInvoice.ID != null){
          this.GetInvoice(this.DocumentID, true, false);
        }
        }
    
        this.DocumentBodyLoading = false;
    
      });
    
    }

    AutoPrintInvoice(i:any){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        InvoiceID:i.ID,
      };
    
      this.DocumentBodyLoading = true;
    
      this.service.ExportInvoice(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.parent.AutoPrintDocument(Document);
        }
    
        this.DocumentBodyLoading = false;
      });
    }

    //end invoice

    //reception

    CurrentReception:any;
    showReceptionVisualizer:boolean;
    ExchangeToTargetCurrency:boolean = false;

    ViewReception(r:any){

      if(r.DocumentStatus.ID == -1){
        return;
      }
  
      this.router.navigate(['/dashboard/purchases/reception'], { queryParams: { id: r.ID } }); 
    }
  
    GenerateStorno(r:any){
      this.router.navigate(['/dashboard/purchases/reception'], { queryParams: { id: r.ID, IsStorno: true } }); 
    }
  
    GetReception(ID:any){
  
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ID:ID,
        WithInfo:true,
        ExchangeToTargetCurrency:this.ExchangeToTargetCurrency,
        IncludeTaxDistributionsInPrice:true
      };
  
      this.service.GetReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CurrentReception = response["Reception"];
          this.CurrentReception.Products = this.CurrentReception.Products.filter(x => x.ProductReceptionInfo.GeneralType.IsTaxConsumed != true);
          this.showReceptionVisualizer = true;
        }

        this.parent.loading = false;
      });
    }
  
    ExportReception(r:any){
  
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ReceptionID:r.ID,
      };
  
      this.DocumentBodyLoading = true;
  
      this.service.ExportReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.download(Document.Name, Document.PDFStream);
        }
  
        this.DocumentBodyLoading = false;
      });
    }
  
    PrintReception(r:any){
  
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ReceptionID:r.ID,
      };
  
      this.DocumentBodyLoading = true;
  
      this.service.ExportReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.printPage(Document.Name , Document.PDFStream, Document.ID);
        }
  
        this.DocumentBodyLoading = false;
      });
    }

    CancelReception(reception:any){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ID:reception.ID,
      };
  
      this.parent.loading = true;
  
      this.service.CancelReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.GetReception(this.DocumentID);
        }
  
        this.ShowDeactivateDocumentQuestion = false;
        this.parent.loading = false;
      });
  
    }

    ActivateReception(reception:any){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ID:reception.ID,
      };
  
      this.parent.loading = true;
  
      this.service.ActivateReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.GetReception(this.DocumentID);
        }
  
        this.ShowReactivateDocumentQuestion = false;
        this.parent.loading = false;
      });
  
    }

    AutoPrintReception(i:any){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        ReceptionID:i.ID,
      };
    
      this.DocumentBodyLoading = true;
    
      this.service.ExportReception(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.parent.AutoPrintDocument(Document);
        }
    
        this.DocumentBodyLoading = false;
      });
    }

    GetInvoiceMasterData(){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
      };
  
      this.service.GetInvoiceMasterData(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CashCollectTypes = response["CashCollectTypes"];
          this.currentCashCollettion.Type = this.CashCollectTypes[1];
          this.BankAccounts = response["BankAccounts"];
          this.Currencies = response["Currencies"];
          this.DecimalPrecisions = response["DecimalPrecisions"];
          this.currency = this.Currencies[0];
          this.InvoicePrecision = this.DecimalPrecisions[0];
          this.InitializeNewCashCollection();
        }
     
        this.parent.loading = false;
      });
    }

    ShowCashCollectionContainer:boolean;
    currentCashCollettion: {[k: string]: any} = {};
    CollectionDate = new FormControl(moment());
    CashCollectTypes:any[];
    BankAccounts:any[];
    Currencies:any[];
    DecimalPrecisions:any[];
    CollectionRemainingValue:any;

    InitializeNewCashCollection(){
    
      this.ShowCashCollectionContainer = true; 
      this.currentCashCollettion = {};
      this.currentCashCollettion.Type = this.CashCollectTypes[1];
      this.currentCashCollettion.Currency = this.CurrentInvoice.Currency;
    
      this.CollectionDate = new FormControl(moment());
      this.currentCashCollettion.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
      this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));
    
      this.currentCashCollettion.BankAccount = {};
      this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentCashCollettion.Currency.ID)[0];
    
      this.currentCashCollettion.InvoiceID = this.CurrentInvoice.ID;
      this.currentCashCollettion.InvoiceDetailsID = this.CurrentInvoice.Details.ID;
    
      if(this.CurrentInvoice.Details.CashCollectionRemainingValue >= 0){
        this.currentCashCollettion.Value = JSON.parse(JSON.stringify(this.CurrentInvoice.Details.CashCollectionRemainingValue));
        this.CollectionRemainingValue = JSON.parse(JSON.stringify(this.CurrentInvoice.Details.CashCollectionRemainingValue));
      }
    }

    AddCashCollection(){
  
      this.currentCashCollettion.InvoiceDetailsID = this.CurrentInvoice.Details.ID;
      
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        CashCollect:this.currentCashCollettion,
      };
    
      if(this.CollectionDate.value != null){
        if(this.CollectionDate.value._d != undefined){
          request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
          this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
        }
        else{
          request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
          this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
        }
      }
    
      this.parent.loading = true;
    
      this.service.AddCashCollection(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
            this.GetInvoice(this.CurrentInvoice.ID, false, true);
        }
    
        this.CollectionDate = new FormControl(moment());
        this.parent.loading = false;
      });
    }

    TrackInvoice(i:any){

      if(i.Details?.ShippingDetails?.TrackingLabel?.length > 0){
        const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/track/shipment'], { queryParams: { Courier: i.Details.ShippingDetails.ShippingCompany.Name, Tracking: i.Details.ShippingDetails.TrackingLabel } }));
        window.open(nextUrl, '_blank');
      }
    }

    //end reception
}
